// @flow
import {SERVICES} from './../constants';
import {DependencyResolver} from './dependency-resolver';

import type {Module} from '../annotation/module';
import type {appService} from '../annotation/services';
import type {IDependencyResolver} from '../annotation/di';

export type IComponentServiceCfg = {
	name: string,
	service: string;
}

export interface IModuleContainer {
	register: (name: string, instance: Class<*>) => void;
}

export class ModuleContainer implements IModuleContainer {
	_resolver: IDependencyResolver;

	_services: {
		[string]: appService,
	};

	_views: {
		[string]: Module,
	};

	get resolver (): IDependencyResolver {
		return this._resolver;
	}

	constructor () {
		this._services = {};
		this._views = {}; //is deprecated, for compatibility reasons

		this._resolver = new DependencyResolver(this);
	}


	register (name: string, service: Class<*>) {
		this._services[name] = service;
		return this;
	}

	_setService (name: string, service: Class<*>): void {
		this._services[name] = service;
	}

	registerComponentService (cfg: IComponentServiceCfg): void {
		this._setService(cfg.name, cfg.service);
	}

	/*
	 * Registers the service in the container.
	 * @param {appService} service - Singleton or factory method
	 */
	registerService (name: string, service: appService) {
		if (!name) {
			throw new Error('[APP] Name of service must be presented');
		}

		this._services[name] = service;
		return this;
	}

	/*
	 * Registers the view model in the container.
	 * @param {appService} view - Singleton or factory method
	 */
	registerView (name: string, viewModule: Module) {
		if (!name) {
			throw new Error('[APP] Name of view must be presented');
		}

		this._views[name] = viewModule;
		return this;
	}


	createModule (ModuleConstructor: Function): any {
		return new ModuleConstructor(this._resolver);
	}

	/*
		DEPRECATED
	*/
	//========
	createRouteModule (ModuleConstructor: Function) {
		const router = this.getModuleByName(SERVICES.ROUTER);

		return new ModuleConstructor(
			this._resolver,
			router
		);
	}
	//========

	getModuleByName (moduleName: string): any {
		return this._services[moduleName]
			|| this._views[moduleName];
	}
}
